import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Observable, Subject, of, zip } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap,
  take,
  takeUntil,
} from 'rxjs/operators';

import { Account } from '../shared/sdk/models/Account';
import { AccountService } from '../accounts/account.service';
import { ActivatedRoute } from '@angular/router';
import { GlobalSubscriptionService } from '../subscriptions/global-subscription.service';
import { LanguageService } from '../shared/services/language.service';
import { LoggerService } from '../shared/sdk/services/custom/logger.service';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationService } from '../organizations/organization.service';
import { SDKService } from '../sdk.service';
import { WhiteLabelService } from '../shared/services/whitelabel.service';

@Component({
  selector: 'app-private',
  templateUrl: './private.component.html',
  styleUrls: ['./private.component.css'],
  providers: [NgbPaginationConfig],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateComponent implements OnInit, OnDestroy {
  hideSidebar: Observable<boolean>;
  isSDK: Observable<boolean>;
  isTrial$: Observable<boolean>;
  sidebarExpanded = false;
  sidebarHiddenMobile = false;
  wrapperWide = false;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    public organizationService: OrganizationService,
    public whiteLabelService: WhiteLabelService,
    private accountService: AccountService,
    private cdr: ChangeDetectorRef,
    private languageService: LanguageService,
    private log: LoggerService,
    private ngbPaginationConfig: NgbPaginationConfig,
    private route: ActivatedRoute,
    private globalSubscriptionService: GlobalSubscriptionService,
    private sdkService: SDKService,
  ) {}

  ngOnInit(): void {
    this.log.info('Private: ngOnInit');
    let lang: string;
    let account: Account;

    this.ngbPaginationConfig.maxSize = 3;

    this.isSDK = this.sdkService.isSDK$;

    this.hideSidebar = zip(
      this.route.firstChild.data.pipe(
        map((data) => {
          return !!data.hideSidebar;
        }),
      ),
      this.sdkService.isSideMenuShown$.pipe(map((shown) => !shown))
    ).pipe(
      map(([hs1, hs2]) => !!(hs1 || hs2)),
      catchError(() => of(false)),
      distinctUntilChanged(),
      takeUntil(this.onDestroy$),
    );

    this.isTrial$ = this.globalSubscriptionService.active.pipe(
      map((subs) => !!subs.trial),
      takeUntil(this.onDestroy$),
    );

    this.languageService.current
      .pipe(
        take(1),
        switchMap((current) => {
          lang = current;
          return this.accountService.active;
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe((acc: Account) => {
        account = acc;
        // Serverside identity verification
        //   return this.accountService.getIdentityVerification();
        // }),
        // switchMap((hash) => {

        this.cdr.markForCheck();

        return this.whiteLabelService.isWhiteLabel;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
